export default "__VITE_ASSET__DtRv53Xw__"